import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import { Redirect, useParams } from "react-router-dom"
import ReactSelect from "components/ReactSelect"
import TextArea from "components/TextArea"
import * as Yup from "yup"
import _ from "lodash"
import Typeahead from "components/Typeahead"
import Title from "../general/title"

const EditMUD = () => {
	const [fields, setFields] = useState({
		name: "",
		description: "",
		property: 0,
		tax_number: "",
	})
	const [redirect, setRedirect] = useState(false)
	const [redirectPath, setRedirectPath] = useState("")

	const { id } = useParams()
	const dispatch = useDispatch()
	const { payload, payloadStatus } = useSelector((state) => ({
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}))

	useEffect(() => {
		if (payloadStatus) {
			const mudId = parseInt(id)
			const mudFields = _.find(payload.public.muds, { id: mudId })
			setFields(mudFields)
		}
	}, [payloadStatus, payload, id])

	const validation = Yup.object().shape({
		name: Yup.string().required("Required"),
		description: Yup.string().required("Required"),
		property: Yup.number().moreThan(0).required("Required"),
	})

	const submitClasses = (isValid) => {
		var classNames = require("classnames")
		return classNames("form__submit", {
			"form__submit--ready": isValid,
		})
	}

	if (!payloadStatus) {
		return ""
	} else if (redirect) {
		return <Redirect to={"/admin/muds"} />
	}

	let mud = _.find(payload.public.muds, { id: parseInt(id) })
	let rate
	if (mud && mud.rate) {
		rate = mud.rate
	}

	return (
		<div>
			<Title title="Edit MUD" showDate={false} />
			<div className="content">
				<Formik
					enableReinitialize
					initialValues={fields}
					validationSchema={validation}
					validateOnMount={true}
					onSubmit={(values) => {
						delete values.rate
						dispatch(loadingStatus(true))
						submitData("updateMUD", values).then((data) => {
							dispatch(loadingStatus(false))
							setRedirect(true)
							setRedirectPath(data.redirect)
							dispatch(getPayload())
						})
					}}>
					{(formik) => (
						<div className="editCommunity">
							<Form>
								<ul className="form__list">
									<li className={fieldStatus("name", formik)}>
										<label htmlFor="name">
											Name <sup>*</sup>
										</label>
										{formik.errors.name && formik.touched.name && (
											<div className="form__message">{formik.errors.name}</div>
										)}
										<Field name="name" type="text" className="form__input" />
									</li>
									<li className={fieldStatus("description", formik)}>
										<label htmlFor="description">Description</label>
										{formik.errors.description && formik.touched.description && (
											<div className="form__message">{formik.errors.description}</div>
										)}
										<TextArea
											name="description"
											className="form__textarea"
											value={formik.values.description}
											onChange={formik.setFieldValue}
											onBlur={formik.setFieldTouched}
										/>
									</li>
									<li className={fieldStatus("property", formik)}>
										<label htmlFor="property">
											Property <sup>*</sup>
										</label>
										{formik.errors.property && formik.touched.property && (
											<div className="form__message">{formik.errors.property}</div>
										)}
										<ReactSelect
											name={`property`}
											options={_.map(payload.public.properties, (v) => ({
												label: v.name,
												value: v.id,
											}))}
											value={formik.values.property}
											onBlur={formik.setFieldTouched}
											onChange={formik.setFieldValue}
										/>
									</li>
									<li className={fieldStatus("tax_number", formik)}>
										<label htmlFor="tax_number">
											Tax Record {rate && <span className="text-[10px] ml-2 text-blue">Current Rate: {rate}</span>}
										</label>
										{formik.errors.tax_number && formik.touched.tax_number && (
											<div className="form__message">{formik.errors.tax_number}</div>
										)}
										<Typeahead
											name="tax_number"
											className="form__input"
											fullWidth={true}
											onChange={(k, v) => {
												if (v === -1) return
												formik.setFieldValue("tax_number", v.tax_number)
											}}
											onBlur={formik.setFieldTouched}
											touched={formik.touched.tax_number}
											error={formik.errors.tax_number}
											placeholder={formik.values.tax_number || "Search for MUD Tax Record"}
											ep="/typeaheadTaxRates"
											returnAll={true}
											clearAfter={true}
										/>
									</li>
								</ul>
								<input type="submit" value="Submit" className={submitClasses(formik.isValid)} />
							</Form>
						</div>
					)}
				</Formik>
			</div>
		</div>
	)
}

export default EditMUD
